export function getLegacyRedirects() {
  return [
    { from: '/men', to: '/men/all', key: 'legacy-0' },
    { from: '/shop', to: '/', key: 'legacy-23' },
    { from: '/women', to: '/women/all', key: 'legacy-1' },
    { from: '/men-pants', to: '/men/pants', key: 'legacy-6' },
    { from: '/men_pants', to: '/men/pants', key: 'legacy-7' },
    { from: '/men-suits', to: '/men/suits', key: 'legacy-8' },
    { from: '/men_suits', to: '/men/suits', key: 'legacy-9' },
    { from: '/men-shirts', to: '/men/shirts', key: 'legacy-4' },
    { from: '/men_shirts', to: '/men/shirts', key: 'legacy-5' },
    { from: '/men-outfits', to: '/men/outfits', key: 'legacy-10' },
    { from: '/men_outfits', to: '/men/outfits', key: 'legacy-11' },
    { from: '/women-outfits', to: '/women/outfits', key: 'legacy-20' },
    { from: '/women_outfits', to: '/women/outfits', key: 'legacy-21' },
    { from: '/men-jackets-and-vests', to: '/men/jackets', key: 'legacy-2' },
    { from: '/men_jackets_and_vests', to: '/men/jackets', key: 'legacy-3' },
    { from: '/women-tops-and-jackets', to: '/women/tops', key: 'legacy-12' },
    { from: '/women_tops_and_jackets', to: '/women/tops', key: 'legacy-13' },
    { from: '/women-pants-and-shorts', to: '/women/pants', key: 'legacy-18' },
    { from: '/women_pants_and_shorts', to: '/women/pants', key: 'legacy-19' },
    { from: '/women-skirts-and-dresses', to: '/women/dresses', key: 'legacy-16' },
    { from: '/women_skirts_and_dresses', to: '/women/dresses', key: 'legacy-17' },
    { from: '/women-suits-and-jumpsuits', to: '/women/suits', key: 'legacy-14' },
    { from: '/women_suits_and_jumpsuits', to: '/women/suits', key: 'legacy-15' },
    { from: '/view-look/:proper_category/:look_id', to: '/men/suits', key: 'legacy-22' },

    /* Fixing botched designer slugs */
    { from: '/designer/choice-jeans-brandd', to: '/designer/choice-jeans-brand', key: 'legacy-33' },
    { from: '/designer/ghinaghandourbyg', to: '/designer/ghina-ghandour-by-g', key: 'legacy-34' },
    { from: '/designer/geminicestmoi', to: '/designer/gemini-cest-moi', key: 'legacy-35' },
    { from: '/designer/lamianassif', to: '/designer/lamia-nassif', key: 'legacy-36' }
  ];
}
